<template>
    <el-dialog
        title="Pre-fill from job"
        :visible.sync="showForm"
        append-to-body
        @closed="reset">

        <el-row class="mt-10" v-if="loadingJobs">
            <el-col :span="24">
                <el-alert
                    type="info"
                    :closable="false">
                    <i class="fad fa-spinner-third fa-spin fa-2x spinned-icon"></i>Loading employer's jobs ...
                </el-alert>
            </el-col>
        </el-row>

        <el-row class="mt-10">
            <el-col :span="24">
                <el-select
                    v-model="jobId"
                    filterable
                    clearable
                    multiple
                    :trigger-on-focus="false"
                    class="full-width"
                    :disabled="employer_id === null || jobs.length === 0"
                    placeholder="Select a job">
                    <el-option
                        v-for="item in jobs"
                        :key="`job-${item.id}`"
                        :label="`${item.id} - ${item.name}`"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
            <btn :click="() => showForm = false" cssClass="btn-default" icon="fal fa-times">Close</btn>
            <btn :click="prefill" cssClass="btn-primary" :disabled="jobId.length === 0">Pre-fill from job</btn>
        </span>

    </el-dialog>
</template>

<script>
export default {
    props: [
        'show',
        'employer_id',
    ],
    data() {
        return {
            jobId: [],
            jobs: [],
            loadingJobs: false,
        };
    },
    computed: {
        showForm: {
            get() { return this.show; },
            set(val) { this.$emit('close'); },
        },
    },
    watch: {
        show: function (val) {
            if (val) {
                this.loadJobs();
            } else {
                this.reset();
            }
        },
    },
    methods: {
        prefill() {
            this.$emit('prefill', { job_id: this.jobId });
            this.showForm = false;
        },
        reset() {
            this.jobId = [];
            this.jobs = [];
        },
        loadJobs() {
            const self = this;
            self.loadingJobs = true;
            axios.get(url(`admin/employer/${self.employer_id}/jobs/dropdown`))
                 .then((response) => {
                     self.jobs = response.data;
                     self.loadingJobs = false;
                 });
        },
    },
};
</script>

<style scoped>
.mt-10 {
    margin-top: 10px;
}

.full-width {
    width: 100%;
}

.spinned-icon {
    position: relative;
    top: -3px;
    left: -7px;
}
</style>